import { useMongoAdd, useMongoDelete, useMongoLazyQueries, useMongoUpdate } from "contexts/useMongoQuery";

export const useOpeningTimesMutations = () => {
  return {
    insertOpeningTime: useInsertOpeningTime(),
  }
}

// openint_timesにドキュメントを追加する
const useInsertOpeningTime = () => {
  const [insertOpeningTimeMutation] = useMongoAdd("opening_times");
  const insertOpeningTime = async (opening_time: OpeningTime) => {
    // @ts-ignore
    const insertedOpeningTime = await insertOpeningTimeMutation(opening_time);
    return insertedOpeningTime;
  };
  return insertOpeningTime;
}


// ボタン押下時に処理を動かすのでuseLazyQueryを使う。
// 公開枠の重複チェック
export const useValidateOpening = () => {
  const [fetch, {called, loading, data}] = useMongoLazyQueries("opening_times")
  const validateOpeningTime = (query:KV) => fetch({
    modality: query.modality,
    weekday: query.weekday,
    $or: [
      {
        start: { $gte : query.start, $lt: query.end }
      },{
        end: { $gt : query.start, $lte: query.end }
      },{
        start: { $lte : query.start }, end: { $gte: query.end }
      },{
        start: { $gte : query.start }, end: { $lt: query.end }
      }
    ]
  })
  const opening_times = data ?? []
  return {
    validateOpeningTime,
    loading,
    called,
    opening_times
  }
}

export const useUpdateOpeningTime = (completed?: () => void) => {
  const [updateDataMutation, { error }] = useMongoUpdate("opening_times", false, {}, completed);
  const updateData = async (id: string | number, set: { [key: string]: any }): Promise<{ updatedData: { [key: string]: any }, error: Error | undefined }> => {
    const { data } = await updateDataMutation({ _id: id }, set);
    const updatedData: { [key: string]: any } = data?.updatedData || {}
    return { updatedData: updatedData, error };
  };
  return updateData;
}

export const useDeleteOpeningTime = (completed?: () => void) => {
  const [deleteDataMutation, { error }] = useMongoDelete("opening_times", false, {}, completed);
  const deleteData = async (id: string | null) => {
    // @ts-ignore
    const deleteOpeningTime = await deleteDataMutation({ _id: id });
    return deleteOpeningTime;
  };
  return deleteData;
}

// 日付別用 ボタン押下時に処理を動かすのでuseLazyQueryを使う。
// 公開枠の重複チェック
export const useValidateDailyOpening = () => {
  const [fetch, {called, loading, data}] = useMongoLazyQueries("opening_times")
  const validateOpeningTime = (query:KV) => fetch({
    modality: query.modality,
    weekday: 99,
    $or: [
      {
        start: { $gte : query.start, $lt: query.end }
      },{
        end: { $gt : query.start, $lte: query.end }
      },{
        start: { $lte : query.start }, end: { $gte: query.end }
      },{
        start: { $gte : query.start }, end: { $lt: query.end }
      }
    ]
  })
  const opening_times = data ?? []
  return {
    validateOpeningTime,
    loading,
    called,
    opening_times
  }
}